import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { LogIn } from "lucide-react";
import axios from "axios";
import PetrocontrolLogo from "@/components/PetrocontrolLogo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await axios.post(`${API}/admin/login`, { email, password }, { withCredentials: true });
      onLogin();
    } catch {
      setError("Credenciales invalidas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#152238] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <div className="flex justify-center mb-6">
            <PetrocontrolLogo className="h-12" />
          </div>
          <h1 className="font-heading text-xl font-bold text-white/80 tracking-[-0.02em]">Panel de Administracion</h1>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5" data-testid="admin-login-form">
          <div>
            <label className="block text-xs font-medium text-white/50 mb-2 uppercase tracking-wider">Correo</label>
            <Input
              data-testid="admin-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@petrocontrol.mx"
              className="rounded-xl bg-white/5 border-white/10 text-white placeholder:text-white/30 h-12 focus:border-[#103F38] focus:ring-[#103F38]"
              required
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-white/50 mb-2 uppercase tracking-wider">Contrasena</label>
            <Input
              data-testid="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Ingresa tu contrasena"
              className="rounded-xl bg-white/5 border-white/10 text-white placeholder:text-white/30 h-12 focus:border-[#103F38] focus:ring-[#103F38]"
              required
            />
          </div>

          {error && <p data-testid="admin-login-error" className="text-red-400 text-sm text-center">{error}</p>}

          <Button
            type="submit"
            data-testid="admin-login-btn"
            disabled={loading}
            className="w-full bg-[#103F38] text-white hover:bg-[#0c332d] rounded-full h-12 font-semibold transition-all"
          >
            {loading ? "Ingresando..." : <><LogIn className="h-4 w-4 mr-2" />Iniciar Sesion</>}
          </Button>
        </form>
      </div>
    </div>
  );
}
